<template>
  <div class="flex w-full">
    <Dropdown
      v-model="selectedCountry"
      :options="countries"
      optionLabel="name"
      :placeholder="translationHandler.translate('Select a Country')"
      filter=""
      class="w-auto"
    >
      <template #value="slotProps">
        <div v-if="slotProps.value" class="flex align-items-center">
          <img
            :alt="slotProps.value.label"
            :src="`/flags/${slotProps.value.code.toLowerCase()}.svg`"
            :class="`mr-2 flag flag-${slotProps.value.code.toLowerCase()}`"
            style="width: 18px"
          />
          <div>{{ CountriesLanguagesHandler.translateCountry(slotProps.value.code) }}</div>
        </div>
        <span v-else>
          {{ slotProps.placeholder }}
        </span>
      </template>
      <template #option="slotProps">
        <div class="flex align-items-center">
          <img
            :alt="slotProps.option.label"
            :src="`/flags/${slotProps.option.code.toLowerCase()}.svg`"
            :class="`mr-2 flag flag-${slotProps.option.code.toLowerCase()}`"
            style="width: 18px"
          />
          <div>{{ slotProps.option.name }}</div>
        </div>
      </template>
    </Dropdown>

    <InputText type="text" :class="'w-full p-2 ml-2 rounded'"
      :placeholder="translationHandler.translate('Type your phone number')"
      @keydown="onKeyDown($event)"
      @keyup.enter="emit('triggerEnter')"
      v-model="inputValue" />

  </div>
</template>
<script setup>
import { ref, watch, defineEmits, onMounted, defineProps } from 'vue';
import { AsYouType, getExampleNumber } from 'libphonenumber-js/mobile';
import Dropdown from 'primevue/dropdown';
import examples from 'libphonenumber-js/mobile/examples';
import translationHandler from '@/composables/handlers/TranslationHandler';
import CountriesLanguagesHandler from '@/composables/handlers/CountriesLanguagesHandler';
import { InputText } from 'primevue';

const emit = defineEmits(['update:modelValue', 'selectedCountry', 'triggerEnter']);

const countries = ref([]);
const selectedCountry = ref();
const inputValue = ref('')
const maxDigits = ref(15);

const props = defineProps({
  hasPhoneValue: {
    type: Boolean,
    required: false,
    default: false
  }
});

const hasPhoneValue = ref(false);
onMounted(() => {
    hasPhoneValue.value = props.hasPhoneValue;
    selectedCountry.value = { name: 'Brazil', code: 'BR' };
    emit('selectedCountry', selectedCountry.value);

    generateCountryTranslations();
});

async function generateCountryTranslations() {
  countries.value = CountriesLanguagesHandler.getAsComboList()
}

watch(selectedCountry, () => {
  try {
    const example = getExampleNumber(selectedCountry.value.code, examples);
    maxDigits.value = example?.nationalNumber.length || 15
  } catch {
    maxDigits.value = 15;
  }
});

watch(hasPhoneValue, (newValue) => {
  hasPhoneValue.value = newValue;
  if (hasPhoneValue.value == false) {
    inputValue.value = '';
  }
});

function onKeyDown(event) {
  const key = event.key

  if (
    key === 'Backspace' || key === 'Delete' ||
    key === 'ArrowLeft' || key === 'ArrowRight' ||
    key === 'Tab' || key === 'Enter'
  ) {
    return
  }

  if (!/^\d$/.test(key)) {
    event.preventDefault()
    return
  }

  const digits = inputValue.value.replace(/\D/g, '')

  if (digits.length >= maxDigits.value) {
    event.preventDefault()
  }
}

watch([inputValue, selectedCountry], ([newInput]) => {
  const formatter = new AsYouType(selectedCountry.value.code)
  inputValue.value = formatter.input(newInput)

  emit('update:modelValue', formatter.getNumberValue() || inputValue.value);
  emit('selectedCountry', selectedCountry.value);
});

</script>
